import type { ReactNode } from "react";
import { Drawer } from "vaul";

export interface SheetProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  title: string;
  /** Visually hide the title (it is still announced). */
  hideTitle?: boolean;
  children: ReactNode;
}

/** Bottom sheet for phone and touch-wide layouts (Vaul). */
export function Sheet({ open, onOpenChange, title, hideTitle, children }: SheetProps) {
  return (
    <Drawer.Root open={open} onOpenChange={onOpenChange}>
      <Drawer.Portal>
        <Drawer.Overlay className="fixed inset-0 z-40 bg-ink/30" />
        <Drawer.Content
          aria-describedby={undefined}
          className="safe-bottom fixed inset-x-0 bottom-0 z-50 mx-auto flex max-h-[92dvh] max-w-[640px] flex-col rounded-t-[20px] bg-surface outline-none"
        >
          <div
            className="mx-auto mt-2.5 h-1.5 w-10 shrink-0 rounded-full bg-line"
            aria-hidden="true"
          />
          <Drawer.Title className={hideTitle ? "sr-only" : "px-5 pt-3 pb-1 text-lg font-extrabold"}>
            {title}
          </Drawer.Title>
          <div className="min-h-0 flex-1 overflow-y-auto px-5 pb-4">{children}</div>
        </Drawer.Content>
      </Drawer.Portal>
    </Drawer.Root>
  );
}
